import styled from 'styled-components'

export default styled.li`
  display: block;
  font-family: 'Spezia', Arial, Helvetica, sans-serif;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0;
  text-align: left;
  top: 0;
  height: auto;
  margin: 0;
  margin-bottom: 0;
  width: 100vw;

  &:last-of-type {
    margin-bottom: 0;
  }

  &:hover {
    &:before {
      background: none;
    }
  }

  a {
    color: ${(props) => (props.inverted ? '#35459C' : '#FFF')};
  }

  @media (min-width: 1200px) {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    position: relative;
    background-color: ${(props) => (props.inverted ? '#FFF' : 'transparent')};
    border-radius: 2px;
    text-transform: capitalize;
    font-size: 13px;
    color: white;
    top: -30px;
    width: auto;
    height: 90px;

    > .hoverChildLinks {
      display: none;
    }

    &:hover {
      > .hoverParentLink {
        position: relative;

        &:before {
          content: '';
          background: #5e79fb;
          width: 100%;
          display: block;
          position: absolute;
          bottom: 0;
          left: 0;
          height: 2px;
        }
      }

      > .hoverChildLinks {
        display: block;
        top: 125px;
        z-index: -1;
      }
    }
  }
`
